import { render, staticRenderFns } from "./AltLocationDetail.vue?vue&type=template&id=0cb55bb8&scoped=true"
import script from "./AltLocationDetail.vue?vue&type=script&lang=js"
export * from "./AltLocationDetail.vue?vue&type=script&lang=js"
import style0 from "./AltLocationDetail.vue?vue&type=style&index=0&id=0cb55bb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb55bb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VChip,VDataTable,VIcon,VSelect})
